// firebase/userService.js
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";

// Lấy dữ liệu user Firestore
export const getFirebaseUser = async (uid) => {
  if (!uid) return null;
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data() : null;
};

// Cập nhật hoặc tạo mới user Firestore
export const saveFirebaseUser = async (uid, userData) => {
  if (!uid) throw new Error("Missing uid");
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    // Cập nhật
    await updateDoc(docRef, {
      ...userData,
      updatedAt: new Date()
    });
  } else {
    // Tạo mới
    await setDoc(docRef, {
      ...userData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
  }
};

// Kiểm tra trạng thái user
export const checkUserStatus = async (uid) => {
  const userData = await getFirebaseUser(uid);
  if (!userData) return { isValid: true, userData: null }; // Chưa có user => không khóa

  if (userData.isDelete)
    return { isValid: false, error: "deleted", userData };

  if (userData.isBlocked)
    return { isValid: false, error: "blocked", userData };

  return { isValid: true, userData };
};

// Nếu cần: set trạng thái bị block hoặc xóa
export const blockFirebaseUser = async (uid, isBlocked = true) => {
  if (!uid) throw new Error("Missing uid");
  const docRef = doc(db, "users", uid);
  await updateDoc(docRef, {
    isBlocked,
    updatedAt: new Date(),
  });
};

export const deleteFirebaseUser = async (uid, isDelete = true) => {
  if (!uid) throw new Error("Missing uid");
  const docRef = doc(db, "users", uid);
  await updateDoc(docRef, {
    isDelete,
    updatedAt: new Date(),
  });
};
